<template>
    <b-card
        class="mt-2 slide-in-top"
        :header="heading"
        border-variant="light"
        header-bg-variant="dark"
        header-text-variant="navy">
        <b-card-text v-html="content">
        </b-card-text>
    </b-card>
</template>

<script>

export default {
    name: "TextBlock",
    props: {
        block: {
            type: String,
            required: true,
        }
    },
    data: function () {
        return {
            content: '',
            title: '',
            heading: '',
        };
    },
    mounted() {
        this.axios.get(this.$Bologna.secure_url(`/v1/textblock/${this.$i18n.locale}/${this.block}`))
            .then(response => {
                    this.content = this.$purify.sanitize(response.data.data.content);
                    this.heading = this.$purify.sanitize(response.data.data.heading);
                    this.title = this.$purify.sanitize(response.data.data.title);
                }
            ).catch(error => {
            this.heading = 'Error';
            this.content = this.$purify.sanitize(this.$shared.errorHandlerForResponder(error));
        });
    }
}
</script>
